export default "__VITE_ASSET__a0433139__"